import styled, { css } from 'styled-components'

export default styled.div`
  ${({
    isButton,
    theme: {
      addDialog: {
        notificationSuccessBGColor,
        languageSwitchBGColor,
        emptyStateBorder,
        emptyStateShadow,
        emptyStateText,
      },
    },
  }) => css`
    display: grid;
    place-items: center;
    padding: 28px 46px 24px;
    border-radius: 24px;
    color: ${emptyStateText};

    ${isButton &&
    css`
      background: ${notificationSuccessBGColor};
      border: 1px solid ${emptyStateBorder};
      box-shadow: ${emptyStateShadow};
      backdrop-filter: blur(16px);
      transition: transform 0.2s ease, border-color 0.2s ease, background 0.2s ease;
      cursor: pointer;

      :hover {
        background: ${languageSwitchBGColor};
        transform: translateY(-3px);
      }
    `}

    lord-icon {
      width: 200px;
      height: 200px;
    }

    .icon-label {
      font-size: 17px;
      font-weight: 650;
      letter-spacing: 0.2px;
      margin-top: -6px;
    }

    @media (max-width: 600px) {
      padding: 22px 30px 20px;
      border-radius: 20px;

      lord-icon {
        width: 160px;
        height: 160px;
      }
    }
  `}
`
